export const translations = {
	'Log in to Ceeview': { no: 'Logg inn i Ceeview' },
	'Username': { no: 'Brukernavn' },
	'Your username': { no: 'Ditt brukernavn' },
	'Password': { no: 'Passord' },
	'Your password': { no: 'Ditt passord' },
	'Show password': { no: 'Vis passord' },
	'Hide password': { no: 'Skjul passord' },
	'Log in': { no: 'Logg inn' },
	'Try your password again': { no: 'Prøv passordet på nytt' },
	'There might be a problem with your internet connection. Credentials not sent': {
		no: 'Det kan være et problem med nettverket. Brukerinformasjon er ikke sendt',
	},
};
